/**
 * @file chart.provider.tsx
 * @description Провайдер компонента диаграмм для Task Manager приложения, который обеспечивает интеграцию основного компонента Chart с контекстом поиска SearchTextProvider. Предоставляет изолированную область видимости для состояния поиска в рамках функциональности диаграмм и передает все входящие пропсы в основной компонент Chart.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['@features/catalog/context/search-text-context', './chart.component']
 * @related-files ['src/features/chart/chart.component.tsx', 'src/features/catalog/context/search-text-context.tsx']
 */

import { SearchTextProvider } from '@features/catalog/context/search-text-context';
import { Chart as ChartMain } from './chart.component';

export const Chart = (props: any) => {
    return (
        <SearchTextProvider>
            <ChartMain {...props} />
        </SearchTextProvider>
    );
};